<template>
    <div class="content main-container">
        <div class="btn-item">
            <Button type="primary" @click="$refs.add.open({ baseId: $route.query.id })">新增</Button>
            <Button ghost type="primary" @click="pageBack">返回</Button>
        </div>

        <div class="table-box">
            <loading :isShow="loading" />
            <Table :columns="columns" :data="tableList">
                <template slot-scope="{ row }" slot="action">
                    <span class="table-btn" :class="{ 'disabled': row.isEffective == 1 }"
                        @click="$refs.add.open(row)">编辑</span>
                    <span class="table-btn" :class="{ 'disabled': row.isEffective == 1 }" @click="remove(row)">删除</span>
                </template>
            </Table>
        </div>
        <div class="pageBox">
            <Page :total="allData.total" :current="search.pageNo" :page-size="allData.size" show-total
                @on-change="pageChange" style="text-align: center;" />
        </div>

        <!-- 新增/编辑 -->
        <add-keep ref="add" :initList="getBasicLawList"></add-keep>
    </div>
</template>
<script>
import { common } from '@/api/mixins';
import addKeep from './components/addKeep.vue';
export default {
    mixins: [common],
    components: { addKeep },
    data() {
        return {
            search: {
                type: 2,
                pageNo: 1,
                pageSize: 10
            },
            userInfo: JSON.parse(localStorage.getItem('userInfo')),
            loading: false,
            columns: [
                {
                    title: '序号',
                    type: 'index',
                    width: 80,
                    align: 'center'
                },
                {
                    title: '维持职级',
                    key: 'oldRankName',
                    width: 250,
                    align: 'center'
                },
                {
                    title: '维持条件',
                    key: 'commissionName',
                    minWidth: 300,
                    align: 'center'
                },
                {
                    title: '维持要求',
                    key: 'ruleName',
                    minWidth: 200,
                    align: 'center'
                },
                {
                    title: '操作',
                    slot: 'action',
                    width: 130,
                    align: 'center',
                    fixed: 'right'
                }
            ],
            tableList: [],
            allData: {},
            id: ''
        };
    },

    created() {
        this.search.baseId = this.$route.query.id;
        this.getBasicLawList();
    },

    methods: {
        remove(row) {
            this.$notice.inquiry('是否确认删除该选项？').then(() => {
                this.$http({
                    url: '/buz/promotionRule/delete',
                    type: 'GET',
                    data: {
                        id: row.id
                    }

                })
                    .then(res => {
                        this.$Message.success('操作成功')
                        this.getBasicLawList()
                    })
            })
        },
        // 基本法列表
        getBasicLawList(index) {
            if (index) {
                this.search.pageNo = index;
            }
            this.loading = true;
            this.$http({
                url: '/buz/promotionRule/read/list',
                type: 'POST',
                data: this.search
            })
                .then(res => {
                    this.loading = false;
                    this.allData = res;
                    this.tableList = res.data;
                })
                .catch(e => {
                    this.loading = false;
                });
        },

        // 分页
        pageChange(index) {
            this.search.pageNo = index;
            this.getBasicLawList();
        },

        // 返回
        pageBack() {
            const fullPath = this.$route && this.$route.fullPath;
            window.parent.postMessage(
                {
                    removePageTag: fullPath,
                    appMessage: true
                },
                '*'
            );
            setTimeout(() => {
                this.openPageTabTags('/basicLawNew/config', {});
            }, 200);
        }
    }
};
</script>
<style lang="scss" scoped>
.btn-item {
    margin-bottom: 10px;
    text-align: right;
}

.disabled {
    pointer-events: none;
    color: #c5c8ce;
}
</style>
